import { BasicAsyncEnumerable } from "../BasicAsyncEnumerable.js";
export const skipWhileAsync = (source, predicate) => {
    if (predicate.length === 1) {
        return skipWhileAsync1(source, predicate);
    }
    else {
        return skipWhileAsync2(source, predicate);
    }
};
const skipWhileAsync1 = (source, predicate) => {
    async function* iterator() {
        let skip = true;
        for await (const item of source) {
            if (skip === false) {
                yield item;
            }
            else if (await predicate(item) === false) {
                skip = false;
                yield item;
            }
        }
    }
    return new BasicAsyncEnumerable(iterator);
};
const skipWhileAsync2 = (source, predicate) => {
    async function* iterator() {
        let index = 0;
        let skip = true;
        for await (const item of source) {
            if (skip === false) {
                yield item;
            }
            else if (await predicate(item, index) === false) {
                skip = false;
                yield item;
            }
            index++;
        }
    }
    return new BasicAsyncEnumerable(iterator);
};
